import { useEffect, useState } from "react"
import { Integration, RateCardsConfig } from "../../../../../types"
import { useIntegrationSettingsForm } from "../../../../hooks"
import { useFetchRateCardsConfigsQuery } from "../../../../../redux/queries"
import Form from "../../../form"

interface RateCardsSelectorProps {
  integration: Integration
}

const RateCardsSelector = ({ integration }: RateCardsSelectorProps) => {
  const { app_settings, saveAppSetting } =
    useIntegrationSettingsForm(integration)

  const [selected, setSelectedRateCards] = useState<RateCardsConfig | null>(
    null
  )
  const [selectedID, setSelectedRateCardsID] = useState<number | string>(
    ((app_settings?.settings as Record<string, unknown>)?.rateCardsConfigId as
      | string
      | number) ??
      app_settings?.rateCardsConfigId ??
      ""
  )

  const { data: rateCards = [], isLoading } = useFetchRateCardsConfigsQuery(
    { brand_id: integration?.brand_id },
    {
      skip: !integration?.brand_id
    }
  )

  const setSelected = (rateCardsID: string) => {
    if (rateCardsID !== selectedID) {
      setSelectedRateCardsID(rateCardsID)
      saveAppSetting({ rateCardsConfigId: rateCardsID })
    }
  }

  useEffect(() => {
    const selectedRateCards = rateCards?.find(
      (rc: RateCardsConfig) => rc.id === selectedID + ""
    )
    setSelectedRateCards(selectedRateCards ?? null)
  }, [selectedID, rateCards])

  return (
    <div className="flex items-center pl-9">
      <Form.InlineSelect
        isLoading={isLoading}
        data={rateCards}
        setSelected={setSelected}
        selected={selected}
        label="Choose a rate cards config"
      />
    </div>
  )
}

export default RateCardsSelector
